export default class Screen {
  constructor () {
    this.id = null
    this.type = null
    this.motion = null
    this.delegate = null
    this.association = null
    this.previousAssociation = null
    this.previousMotion = null
  }

  static fromJson (json) {
    let screen = new this()
    if (json.id !== null) {
      screen.id = parseInt(screen.id)
    }
    if (json.type !== null) {
      screen.type = json.type
    }
    if (json.motion !== null) {
      screen.motion = json.motion
    }
    if (json.delegate !== null) {
      screen.delegate = json.delegate
    }
    if (json.association !== null) {
      screen.association = json.association
    }
    if (json.previous_association !== null) {
      screen.previousAssociation = json.previous_association
    }
    if (json.previous_motion !== null) {
      screen.previousMotion = json.previous_motion
    }
    return screen
  }
}



// WEBPACK FOOTER //
// ./src/models/screen.js